export default function clearCookies(keys: string[]) {
  keys.forEach(key => {
    document.cookie = `${key}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;`
  })
}